/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const color = {
  semantic: {
    action: {
      contrastText: '#0e0d24',
      disabledBackground: '#f8f8fa14',
      enabled: '#f8f8fa0a',
      focused: '#7474a2',
      focusOutline: '#9966ab',
      hover: '#f8f8fa14',
      pressed: '#f8f8fa29',
      selected: '#f8f8fa1f',
      selectedContrast: '#f8f8fa',
    },
    background: {
      componentFrame: '#17172b',
      default: '#0e0d24',
      level1: '#17172b',
      level2: '#000818',
    },
    border: {
      error: '#db575d',
      info: '#3e80fa',
      primary: '#9966ab',
      secondary: '#7474a2',
      strong: '#e9e9f0',
      subtle: '#f8f8fa29',
      success: '#529966',
      warning: '#cd793d',
    },
    button: {
      _neutral: {
        hovered: '#f8f8fa1f',
        selected: '#f8f8fa33',
      },
    },
    'data table': {
      cell: {
        error: '#ce1c250f',
        info: '#0158f90f',
        success: '#1b79360f',
      },
      header: '#17172b',
      row: {
        even: '#17172b',
        groupLevel1: '#26264566',
        groupLevel2: '#262645cc',
        odd: '#0e0d24',
      },
      text: {
        error: '#db575d',
        info: '#8fb6fc',
        success: '#529966',
      },
    },
    error: {
      contrast: '#f8f8fa',
      dark: '#fdf6f6',
      hoverSubtle: '#ce1c251a',
      main: '#ce1c25',
      softBg: '#42090c',
      softText: '#f9e3e4',
      subtle: '#080101',
      text: '#db575d',
    },
    info: {
      contrast: '#f8f8fa',
      dark: '#f5f8ff',
      hoverSubtle: '#0158f91a',
      main: '#0158f9',
      softBg: '#001c50',
      softText: '#e0ebfe',
      subtle: '#00030a',
      text: '#8fb6fc',
    },
    link: {
      default: '#3e80fa',
      pressed: '#e9e9f0',
      visited: '#9966ab',
    },
    primary: {
      contrast: '#f8f8fa',
      dark: '#faf7fb',
      hoverSubtle: '#7936901a',
      main: '#793690',
      softBg: '#27112e',
      softText: '#efe7f2',
      subtle: '#050206',
      text: '#c4a7ce',
    },
    progress: {
      baseBar: '#ffffff29',
      primary: '#9966ab',
    },
    scrollbar: {
      thumb: '#262645',
      track: '#f8f8fa03',
    },
    secondary: {
      contrast: '#f8f8fa',
      dark: '#f8f8fa',
      main: '#484885',
      softBg: '#17172b',
      softText: '#e9e9f0',
      subtle: '#0e0d24',
      text: '#afafc9',
    },
    skeleton: {
      skeleton: '#ffffff29',
    },
    success: {
      contrast: '#f8f8fa',
      dark: '#f6faf7',
      hoverSubtle: '#1b79361a',
      main: '#1b7936',
      softBg: '#092711',
      softText: '#e3efe7',
      subtle: '#010502',
      text: '#529966',
    },
    switch: {
      check: '#1b7936',
      disabled: '#f8f8fa14',
    },
    text: {
      contrast: '#0e0d24',
      disabled: '#ffffff52',
      primary: '#f8f8fa',
      secondary: '#afafc9',
    },
    tooltip: {
      background: '#f8f8fa',
      text: '#0e0d24',
    },
    warning: {
      contrast: '#f8f8fa',
      dark: '#fcf8f5',
      hoverSubtle: '#bd4f001a',
      main: '#bd4f00',
      softBg: '#3d1900',
      softText: '#f7eae0',
      subtle: '#070300',
      text: '#cd793d',
    },
  },
} as const;

export const colorSemantic = color.semantic;
